<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">Note Contratto di Servizio</span>
		</v-card-title>
		<v-card-text class="pt-6">
			<v-row v-if="contrattoDiServizio.id === null">
				<v-col>
					Nessun contratto di servizio associato
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-textarea
						outlined
						class="mt-1"
						:value="contrattoDiServizio.notes"
						@input="contrattoDiServizio.notes = $event !== '' ? $event : null"
						:disabled="contrattoDiServizio.id === null"
					></v-textarea>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="close()"
				:disabled="isSaving"
				class="black--text"
			>
				{{ contrattoDiServizio.notes !== backupContrattoDiServizio.notes ? 'Annulla' : 'Chiudi' }}
			</v-btn>
			<v-btn
				color="secondary"
				@click="update()"
				:disabled="isSaving || contrattoDiServizio.notes === backupContrattoDiServizio.notes"
				:loading="isSaving"
			>
				Salva
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: {
		value: {
			default: null
		},
	}, // pratica object
	data() {
		return {
			backupContrattoDiServizio: null,
			contrattoDiServizio: {
				id: null,
				notes: null
			},
			isSaving: false
		}
	},
	
	created() {
		this.backupContrattoDiServizio = Object.assign({}, this.value || this.praticaVoid.contratto_di_servizio);
		this.contrattoDiServizio = Object.assign({}, this.value || this.praticaVoid.contratto_di_servizio);
	},
	
	methods: {
		update() {
			this.isSaving = true;
			let contrattoDiServizio = {
				id: this.contrattoDiServizio.id,
				notes: this.contrattoDiServizio.notes
			}
			let formData = new FormData();
			formData.append('contratto_di_servizio', JSON.stringify(contrattoDiServizio));
			axios.patch(`/api/contratti-di-servizio/${contrattoDiServizio.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.$emit('contratto-di-servizio-updated', {
						contrattoDiServizioUpdated: response.data
					})
					this.close();
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		close() {
			this.$emit('close');
		}
	}
}
</script>